import { FontWeight, Markdown } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const List = styled.ol``;

export const CalculationData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledMarkdown = styled(Markdown)`
  strong {
    font-weight: ${FontWeight.SemiBold};
  }

  &::before {
    content: '•';
    margin-right: 10px;
  }
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  position: relative;
  top: 4px;
  left: 10px;
`;
